<template>
  <v-flex class="mt-6 mx-4">
    <v-dialog v-model="dialogFormularioReserva" :width="dialogWidth" persistent>
      <reserva-formulario :modelReserva="this.modelReserva" :accion="this.accion"
        @cerrarFormularioReserva="_actualizarDatos" @actualizar="_actualizar"
        @cerrar="dialogFormularioReserva = false" />
    </v-dialog>

    <v-row v-if="showLoading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col>
          <v-progress-linear class="mt-12 mb-12" :color="colorEBikeAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-row v-if="!showLoading">
      <!--  <v-card class="mt-0 mb-2 pt-2 pb-0" outlined :color="colorFondo500"> -->


      <div class="table-container">
        <table class="table-style table-sm mx-2">
          <caption></caption>
          <thead>
            <tr>
              <th id="dias_del_mes" class="font-weight-bolder text-uppercase" v-bind:style="{ color: colorFront200 }">
              </th>
              <th id="dias" class="text-center" v-for="day in arrayFechas" v-bind:key="'diasemana' + day" v-bind:style="{
                color: colorFront200,
                'background-color': _colorIsWeekendHeader(day),
              }">
                {{ _inicialDiaSemana(day) }}
              </th>
            </tr>
            <tr>
              <th id="dias_del_mes" class="font-weight-bolder text-uppercase" v-bind:style="{ color: colorFront200 }">
              </th>
              <th id="dias" class="text-center" v-for="day in arrayFechas" v-bind:key="'mes' + day" v-bind:style="{
                color: colorFront200,
                'background-color': _colorIsWeekendHeader(day),
              }">
                {{ day.substring(5, 7) }}
              </th>
            </tr>
            <tr>
              <th id="dias" class="font-weight-bolder text-uppercase" v-bind:style="{ width: '150px' }"></th>

              <th id="dias" class="text-center" v-for="day in arrayFechas" v-bind:key="'dia' + day" v-bind:style="{
                color: colorFront200,
                'background-color': _colorIsWeekendHeader(day),
              }">
                {{ day.substring(8, 10) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="bici in bicis" :key="bici.id">
              <th id="" class="px-6 text-uppercase font-weight-bolder" v-text="_captionNombreBici(bici)"
                v-bind:style="{ color: colorFront200 }" style="text-align: right"></th>
              <td class="px-1 pb-1" v-for="day in arrayFechas" :key="'disp' + day" v-bind:style="{
                'background-color': _colorFondoCelda(day, bici),
              }">
              <!--
                <v-chip class="px-1" :color="_showStatusItem(bici, day)" style="width: 50px" label link small
                  @click="_mostrarDetalleReserva(day, bici)" @contextmenu.prevent="_remarcarReserva(day, bici, true)">
                  <span v-if="_esInicioDeReserva(day, bici)"
                    v-bind:style="{ color: _colorInicioFinal(day, bici), fontSize: '20px' }">
                    &#9654;
                  </span>
                  <span v-bind:style="{ color: _colorTextoCelda(bici, day), fontSize: '12px' }">
                    {{ bici.talla + bici.numero }}
                  </span>
                  <span v-if="_esFinalDeReserva(day, bici)"
                    v-bind:style="{ color: _colorInicioFinal(day, bici), fontSize: '20px' }">
                    &#9664;
                  </span>
                </v-chip>
              -->





                
                <div class="calendario-celda calendario-celda-chip px-1"
                  :style="{ backgroundColor: _showStatusItem(bici, day) }" role="button" tabindex="0"
                  @click="_mostrarDetalleReserva(day, bici)" @contextmenu.prevent="_remarcarReserva(day, bici, true)">
                  <span v-if="_esInicioDeReserva(day, bici)"
                    v-bind:style="{ color: _colorInicioFinal(day, bici), fontSize: '20px', lineHeight: '1' }">
                    &#9654;
                  </span>
                  <span v-bind:style="{ color: _colorTextoCelda(bici, day), fontSize: '12px', lineHeight: '1' }">
                    {{ bici.talla + bici.numero }}
                  </span>
                  <span v-if="_esFinalDeReserva(day, bici)"
                    v-bind:style="{ color: _colorInicioFinal(day, bici), fontSize: '20px', lineHeight: '1' }">
                    &#9664;
                  </span>
                </div>
                
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--  </v-card>-->
    </v-row>
    <v-row v-if="!showLoading" class="mt-6">
      <v-chip class="px-1" :color="colorEBikeAccent1" style="width: 100px; height: 30px" label link small
        @click="irAtras()">
        <v-icon color="white">mdi-chevron-double-left</v-icon>
        <span v-bind:style="{ color: 'white' }"> Anteriores </span>
      </v-chip>

      <v-spacer />

      <v-menu :dark="dark" v-model="showdate" offset-y :close-on-content-click="false" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-text-field style="width: 200px" class="mr-2 shrink" dark dense outlined :value="_captionMonthSelec"
            label="Seleccionar mes" readonly v-on="on" hide-details
            :background-color="colorEBikeAccent1"></v-text-field>
        </template>
        <v-date-picker :dark="dark" locale="es" v-model="monthSelec" @input="showdate = false" type="month"
          color="blue lighten-1" header-color="success" @change="getReservasCalendarioPorMes()"></v-date-picker>
      </v-menu>

      <v-spacer />

      <v-chip class="px-1" :color="colorEBikeAccent1" style="width: 100px; height: 30px" label link small
        @click="irAdelante()">
        <span class="ml-2" v-bind:style="{ color: 'white' }"> Siguientes </span>
        <v-icon color="white">mdi-chevron-double-right</v-icon>
      </v-chip>
    </v-row>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

import ReservaFormulario from "../components/formularios/ReservaFormulario.vue";

export default {
  name: "Anual",

  components: {
    ReservaFormulario,
  },

  data: () => ({
    showdate: false,
    showLoading: true,
    showDetalleReserva: false,
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],

    modelReserva: null,
    dialogFormularioReserva: false,
    accion: "",
    monthSelec: new Date().toISOString().substr(0, 7),
    reservaRemarcada: null,
    celdaStatusPresupuesto: {},
    celdaStatusOtros: {},
    celdaTaller: {},
    celdaInicioReserva: {},
    celdaFinalReserva: {},
    celdaConfirmada: {},
    celdaDetalleReserva: {},
    celdaReservaRemarcada: {},
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",
      "colorEBikeAccent1",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("reservas", [
      "reservasCalendario",
      "tallerCalendario",
      "reservaSelec",
      "dialogWidth",
      "from",
      "until",
    ]),

    ...mapState("bicis", ["bicis"]),

    cantDias() {
      let m = this._captionMonthSelec;
      switch (m) {
        case "Febrero":
          return 28;
          break;
        case "Enero":
        case "Marzo":
        case "Mayo":
        case "Julio":
        case "Agosto":
        case "Octubre":
        case "Diciembre":
          return 31;
          break;
        default:
          return 30;
          break;
      }
    },

    month() {
      return this.monthSelec.substring(5, 7);
    },

    _captionMonthSelec() {
      return this.monthNames[parseInt(this.month) - 1];
    },



    arrayFechas() {
      var res = [];
      for (
        var d = new Date(this.from);
        d <= new Date(this.until);
        d.setDate(d.getDate() + 1)
      ) {
        res.push(this.formatDate(d));
      }
      return res;
    },
  },

  watch: {
    reservasCalendario: {
      handler() {
        this._rebuildCalendarCache();
      },
    },
    tallerCalendario: {
      handler() {
        this._rebuildCalendarCache();
      },
    },
    bicis: {
      handler() {
        this._rebuildCalendarCache();
      },
    },
    arrayFechas() {
      this._rebuildCalendarCache();
    },
    reservaRemarcada() {
      this._rebuildReservaRemarcadaCache();
    },
  },

  mounted() {
    console.log("mounted");
    if (!this.user) {
      this.$router.push("/login");
    }
    let hoy = new Date();

    hoy.setHours(0, 0, 0, 0);
    this.setFrom(new Date(hoy));
    this.setUntil(new Date(Date.now() + 60 * 24 * 60 * 60 * 1000));
    this._getReservasCalendario(
      new Date(Date.parse(this.from) - 2 * 24 * 60 * 60 * 1000),
      this.until,
      true
    );
  },


  methods: {
    ...mapActions("reservas", ["getReservasCalendario"]),
    ...mapMutations("reservas", ["setReservaSelec", "setFrom", "setUntil", "setEstaSolapadaConConfirmada"]),

    _esEstadoConfirmada(estado) {
      return Number(estado && estado.id) == 2;
    },

    _esEstadoPresupuesto(estado) {
      const estadoId = Number(estado && estado.id);
      return estadoId == 1 || estadoId == 3;
    },

    _cellKey(biciId, day) {
      return biciId + "|" + day;
    },

    _maxDateString(a, b) {
      return a > b ? a : b;
    },

    _minDateString(a, b) {
      return a < b ? a : b;
    },

    _forEachDayInRange(fromDay, untilDay, callback) {
      if (!fromDay || !untilDay || fromDay > untilDay) {
        return;
      }

      let cursor = new Date(fromDay + "T00:00:00");
      const last = new Date(untilDay + "T00:00:00");
      while (cursor <= last) {
        callback(this.formatDate(cursor));
        cursor.setDate(cursor.getDate() + 1);
      }
    },

    _rebuildCalendarCache() {
      const celdaStatusPresupuesto = {};
      const celdaStatusOtros = {};
      const celdaTaller = {};
      const celdaInicioReserva = {};
      const celdaFinalReserva = {};
      const celdaConfirmada = {};
      const celdaDetalleReserva = {};

      if (!Array.isArray(this.arrayFechas) || this.arrayFechas.length == 0) {
        this.celdaStatusPresupuesto = celdaStatusPresupuesto;
        this.celdaStatusOtros = celdaStatusOtros;
        this.celdaTaller = celdaTaller;
        this.celdaInicioReserva = celdaInicioReserva;
        this.celdaFinalReserva = celdaFinalReserva;
        this.celdaConfirmada = celdaConfirmada;
        this.celdaDetalleReserva = celdaDetalleReserva;
        this.celdaReservaRemarcada = {};
        return;
      }

      const firstDay = this.arrayFechas[0];
      const lastDay = this.arrayFechas[this.arrayFechas.length - 1];
      const biciIds = new Set((this.bicis || []).map((b) => String(b.id)));

      for (let index = 0; index < this.tallerCalendario.length; index++) {
        const reparacion = this.tallerCalendario[index];
        const biciId = String(reparacion.bici_id);
        if (!biciIds.has(biciId)) {
          continue;
        }
        const fromDay = this._maxDateString(reparacion.fecha_inicial, firstDay);
        const untilDay = this._minDateString(reparacion.fecha_final, lastDay);
        this._forEachDayInRange(fromDay, untilDay, (day) => {
          celdaTaller[this._cellKey(biciId, day)] = true;
        });
      }

      for (let index = 0; index < this.reservasCalendario.length; index++) {
        const reserva = this.reservasCalendario[index];
        const bicisReserva = Array.isArray(reserva.bicis) ? reserva.bicis : [];
        const isConfirmada = this._esEstadoConfirmada(reserva.estado);
        const isPresupuesto = this._esEstadoPresupuesto(reserva.estado);
        const fromDay = this._maxDateString(reserva.fecha_bloqueo, firstDay);
        const untilDay = this._minDateString(reserva.fecha_final, lastDay);

        if (fromDay > untilDay) {
          continue;
        }

        for (let biciIndex = 0; biciIndex < bicisReserva.length; biciIndex++) {
          const biciId = String(bicisReserva[biciIndex].id);
          if (!biciIds.has(biciId)) {
            continue;
          }

          this._forEachDayInRange(fromDay, untilDay, (day) => {
            const cellKey = this._cellKey(biciId, day);

            if (isPresupuesto) {
              celdaStatusPresupuesto[cellKey] = reserva.estado.color;
            } else {
              celdaStatusOtros[cellKey] =
                reserva.fecha_bloqueo <= day && day < reserva.fecha_inicial
                  ? "#8fc292"
                  : reserva.estado.color;
            }

            if (reserva.fecha_bloqueo == day) {
              celdaInicioReserva[cellKey] = true;
            }
            if (reserva.fecha_final == day) {
              celdaFinalReserva[cellKey] = true;
            }

            if (isConfirmada) {
              celdaConfirmada[cellKey] = true;
            }

            const reservaEnCelda = celdaDetalleReserva[cellKey];
            if (isConfirmada) {
              // Si ya hay una presupuestada en la celda, la confirmada debe tener prioridad.
              if (!reservaEnCelda || this._esEstadoPresupuesto(reservaEnCelda.estado)) {
                celdaDetalleReserva[cellKey] = reserva;
              }
            } else if (isPresupuesto && !reservaEnCelda) {
              celdaDetalleReserva[cellKey] = reserva;
            }
          });
        }
      }

      this.celdaStatusPresupuesto = celdaStatusPresupuesto;
      this.celdaStatusOtros = celdaStatusOtros;
      this.celdaTaller = celdaTaller;
      this.celdaInicioReserva = celdaInicioReserva;
      this.celdaFinalReserva = celdaFinalReserva;
      this.celdaConfirmada = celdaConfirmada;
      this.celdaDetalleReserva = celdaDetalleReserva;
      this._rebuildReservaRemarcadaCache();
    },

    _rebuildReservaRemarcadaCache() {
      const celdaReservaRemarcada = {};
      if (
        !this.reservaRemarcada ||
        !Array.isArray(this.arrayFechas) ||
        this.arrayFechas.length == 0
      ) {
        this.celdaReservaRemarcada = celdaReservaRemarcada;
        return;
      }

      const firstDay = this.arrayFechas[0];
      const lastDay = this.arrayFechas[this.arrayFechas.length - 1];
      const fromDay = this._maxDateString(this.reservaRemarcada.fecha_bloqueo, firstDay);
      const untilDay = this._minDateString(this.reservaRemarcada.fecha_final, lastDay);
      const bicisReserva = Array.isArray(this.reservaRemarcada.bicis)
        ? this.reservaRemarcada.bicis
        : [];

      if (fromDay > untilDay) {
        this.celdaReservaRemarcada = celdaReservaRemarcada;
        return;
      }

      for (let index = 0; index < bicisReserva.length; index++) {
        const biciId = String(bicisReserva[index].id);
        this._forEachDayInRange(fromDay, untilDay, (day) => {
          celdaReservaRemarcada[this._cellKey(biciId, day)] = true;
        });
      }

      this.celdaReservaRemarcada = celdaReservaRemarcada;
    },

    _crearReserva() {
      this._inicializarModelReserva();
      this.accion = "crear";
      this.dialogFormularioReserva = true;
    },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },

    _captionTextInsideCell(bici, day) {
      return bici.talla + bici.numero;
      //<span v-bind:style="{ color: 'red', fontSize: '8px' }">&#9654;</span> {{ bici.talla + bici.numero }};
    },

    _inicializarModelReserva() {
      this.modelReserva = {
        id: null,
        fecha_inicial: null,
        fecha_bloqueo: null,
        fecha_final: null,
        ubicacion_inicial: null,
        ubicacion_final: null,

        cant_dias: 0,
        cant_bicis: 0,
        cant_bicis_s: 0,
        cant_bicis_m: 0,
        cant_bicis_l: 0,
        cant_bicis_xl: 0,

        precio: 0.00,
        importe: 0.00,
        fianza: 0.00,
        descuento: 0.00,
        total: 0.00,

        pagado: 0.00,
        pendiente: 0.00,

        transporte_km: 0,
        transporte_precio: 0.00,
        transporte_importe: 0.00,

        casco: false,
        alforjas: false,
        pedales_automaticos: false,
        gps: false,


        kit_pinchazos: false,
        botellin: false,
        candado: false,
        seguro: false,
        bolsa_delantera: false,
        soporte_movil: false,
        credencial: false,

        pedales_automaticos_importe: '0.00',
        seguro_importe: '0.00',
        bolsa_delantera_importe: '0.00',
        soporte_movil_importe: '0.00',
        credencial_importe: '0.00',

        observacion_presupuesto: null,

        sin_iva: false,
        descuento_agencia: false,

        observaciones: null,
        estado: {
          id: null,
          nombre: null,
        },
        cliente: {
          id: null,
          nombre: null,
          dni: null,
          domicilio: null,
          telefono: null,
          email: null,
          observaciones: null,
        },
        bicis: [],
      };
    },

    _captionNombreBici(bici) {
      return bici.marca.substring(0, 1); // + " " + bici.talla + "-" + bici.numero;
    },

    _actualizarDatos() {
      this.dialogFormularioReserva = false;
      this._getReservasCalendario(
        new Date(Date.parse(this.from) - 2 * 24 * 60 * 60 * 1000),
        this.until,
        true
      );
    },

    _actualizar() {
      this._getReservasCalendario(
        new Date(Date.parse(this.from) - 2 * 24 * 60 * 60 * 1000),
        this.until,
        false
      );
    },

    _remarcarReserva(day, bici, remarcar) {
      if (!remarcar) {
        this.reservaRemarcada = null;
      } else {
        const cellKey = this._cellKey(String(bici.id), day);
        this.reservaRemarcada = this.celdaDetalleReserva[cellKey] || null;
        return this.reservaRemarcada;
      }
    },

    _getFechaCompleta(day) {
      var dcero = day;
      if (day < 10) {
        dcero = "0" + day;
      }
      return new Date(this.monthSelec + "-" + dcero)
        .toISOString()
        .substring(0, 10);
    },

    _existeSolapamientoConfirmada(reserva) {
      let reservasConfirmadas = this.reservasCalendario.filter(
        (e) => this._esEstadoConfirmada(e.estado)
      );

      for (let index = 0; index < reservasConfirmadas.length; index++) {
        const res = reservasConfirmadas[index];
        if (
          this._biciEnReserva(res, reserva.bicis[0]) &&
          res.fecha_bloqueo <= reserva.fecha_final &&
          reserva.fecha_bloqueo <= res.fecha_final
        ) {

          return true;
        }
      }
      return false;
    },

    _mostrarDetalleReserva(fecha, bici) {
      const cellKey = this._cellKey(String(bici.id), fecha);
      const reserva = this.celdaDetalleReserva[cellKey] || null;

      if (reserva) {
        this.setReservaSelec(reserva);

        if (this._existeSolapamientoConfirmada(reserva)) {
          this.setEstaSolapadaConConfirmada(true);
        } else {
          this.setEstaSolapadaConConfirmada(false);
        }


        let temp = JSON.parse(JSON.stringify(this.reservaSelec));
        this.modelReserva = temp;
        console.log("modelReserva", this.modelReserva);
        this.accion = "editar";

        this.dialogFormularioReserva = true;
      }
    },

    _showStatusItem(bici, day) {
      const cellKey = this._cellKey(String(bici.id), day);
      if (this.celdaTaller[cellKey]) return "#FFCDD2";
      let color = this.celdaStatusOtros[cellKey] || this.celdaStatusPresupuesto[cellKey];
      if (color != null) return color;
      return "white";
    },

    _biciEnReserva(res, bici) {
      for (let index = 0; index < res.bicis.length; index++) {
        const b = res.bicis[index];
        if (b.id == bici.id) return true;
      }
      return false;
    },

    _estaEnTaller(fecha, bici) {
      const cellKey = this._cellKey(String(bici.id), fecha);
      return Boolean(this.celdaTaller[cellKey]);
    },

    _esInicioDeReserva(day, bici) {
      const cellKey = this._cellKey(String(bici.id), day);
      return Boolean(this.celdaInicioReserva[cellKey]);
    },

    _esFinalDeReserva(day, bici) {
      const cellKey = this._cellKey(String(bici.id), day);
      return Boolean(this.celdaFinalReserva[cellKey]);
    },

    _colorInicioFinal(day, bici) {
      const cellKey = this._cellKey(String(bici.id), day);
      return this.celdaConfirmada[cellKey] ? "red" : "blue";
    },

    _estaEnReserva(fecha, bici) {
      const cellKey = this._cellKey(String(bici.id), fecha);
      return this.celdaStatusOtros[cellKey] || this.celdaStatusPresupuesto[cellKey] || null;
    },

    _getReservaFromBici(fecha, bici) {
      const cellKey = this._cellKey(String(bici.id), fecha);
      return this.celdaDetalleReserva[cellKey] || null;
    },

    _getColorFondoOfReserva(fecha, bici) {
      for (let index = 0; index < this.reservasCalendario.length; index++) {
        const res = this.reservasCalendario[index];
        if (
          this._biciEnReserva(res, bici) &&
          res.fecha_inicial <= fecha &&
          res.fecha_final >= fecha
        ) {
          return res.color;
        }
      }
      return null;
    },

    _colorIsWeekendHeader(day) {
      var today = new Date().toISOString().substr(0, 10);
      if (day == today) {
        return "#90CAF9"; //azul clarito
      }

      if (this._isWeekend(day)) {
        return "rgb(180, 180, 180)";
      } else {
        return "rgb(230, 230, 230)";
      }
    },

    _colorFondoCelda(day, bici) {
      const cellKey = this._cellKey(String(bici.id), day);
      if (this.celdaTaller[cellKey]) return "#F44336"; //rojo
      if (this.celdaReservaRemarcada[cellKey]) return "#2196F3"; //AZUL
      return "rgb(230, 230, 230)";
    },

    _colorTextoCelda(bici, day) {
      const cellKey = this._cellKey(String(bici.id), day);
      if (this.celdaConfirmada[cellKey]) {
        return "white";
      }
      return "grey";
    },

    _inicialDiaSemana(day) {
      let days = ["D", "L", "M", "M", "J", "V", "S"];
      let d = new Date(day);
      let dd = d.getUTCDay();
      return days[dd];
    },

    _isWeekend(fecha) {
      return (
        new Date(fecha).getUTCDay() == 0 || new Date(fecha).getUTCDay() == 6
      );
    },

    getReservasCalendarioPorMes() {
      this.setFrom(new Date(Date.parse(this.monthSelec + "-01")));
      this.setUntil(
        new Date(Date.parse(this.monthSelec + "-" + this.cantDias))
      );
      this._getReservasCalendario(this.from, this.until, true);
    },

    async _getReservasCalendario(from, until, loading) {
      if (loading) {
        this.showLoading = true;
      }
      console.log('from:', from);
      console.log('until:', until);
      await this.getReservasCalendario([
        this.access_token,
        from,
        until,
        loading,
      ]);
      console.log('reservasCalendario:', this.reservasCalendario);
      this._rebuildCalendarCache();
      this.showLoading = false;
    },

    /* loadMoreData({ target: { scrollLeft, clientWidth, scrollWidth } }) {
      if (scrollLeft + clientWidth >= scrollWidth) {
        this.setUntil(
          new Date(Date.parse(this.until) + 30 * 24 * 60 * 60 * 1000)
        );
        this._getReservasCalendario(this.from, this.until, true);
      }
    },*/

    irAtras() {
      this.setFrom(new Date(Date.parse(this.from) - 30 * 24 * 60 * 60 * 1000));
      this._getReservasCalendario(
        new Date(Date.parse(this.from) - 2 * 24 * 60 * 60 * 1000),
        this.until,
        true
      );
    },

    irAdelante() {
      this.setUntil(
        new Date(Date.parse(this.until) + 30 * 24 * 60 * 60 * 1000)
      );
      this._getReservasCalendario(
        new Date(Date.parse(this.from) - 2 * 24 * 60 * 60 * 1000),
        this.until,
        true
      );
    },
  },
};
</script>

<style type="text/css">
.table-container {
  height: calc(100vh - 100px);
  /* Altura deseada para la tabla */
  width: 100%;
  overflow-y: scroll;
  position: relative;
}

.table-style {
  width: 100%;
  border-collapse: collapse;
}

.calendario-celda {
  user-select: none;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.0892857143em;
  text-transform: uppercase;
}

.calendario-celda-chip {
  width: 50px;
  height: 24px;
  padding: 2px 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.calendario-celda:hover {
  opacity: 0.85;
}


thead tr:nth-child(2) th,
thead tr:nth-child(3) th {
  position: sticky;
  top: 1.5em;
  /* Adjust according to the height of your header rows */
  background-color: #f2f2f2;
  z-index: 1;
}

thead tr:nth-child(3) th {
  top: 3em;
  /* Adjust according to the height of your header rows */
}

th,
td {
  text-align: left;
  border: 1px solid #ddd;
}
</style>
